import * as LucideIcons from "lucide-react";
import { SERVICES } from "@/lib/site";

export default function Services() {
  return (
    <section
      id="services"
      data-testid="services-section"
      className="relative py-24 md:py-32 bg-gradient-to-b from-[#0B1120] via-[#0d1428] to-[#0B1120]"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <div className="max-w-3xl mb-14">
          <div className="flex items-center gap-3 mb-5">
            <span className="h-px w-10 bg-orange-500" />
            <span className="font-tech text-orange-400 text-xs">WHAT WE DO</span>
          </div>
          <h2 className="font-display text-4xl md:text-5xl lg:text-6xl leading-[0.95] tracking-tight">
            <span className="chrome-text">Sixteen Verticals.</span>
            <br />
            <span className="ember-text">One Pipeline.</span>
          </h2>
          <p className="mt-6 font-body text-slate-400 max-w-xl">
            From roofing and solar to commercial prospecting and full-funnel CRM support — every
            campaign is engineered for the close.
          </p>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-3 md:gap-4">
          {SERVICES.map((s, i) => {
            const Icon = LucideIcons[s.icon] || LucideIcons.Zap;
            return (
              <div
                key={s.name}
                data-testid={`service-tile-${s.name.toLowerCase().replace(/\s+/g, "-")}`}
                className="service-tile forge-card p-5 md:p-6 group cursor-default"
              >
                <div className="flex items-start justify-between mb-4">
                  <Icon
                    size={24}
                    className="service-icon text-slate-400 transition-all duration-300"
                  />
                  <span className="font-tech text-[10px] text-slate-600">
                    {String(i + 1).padStart(2, "0")}
                  </span>
                </div>
                <div className="font-display text-base md:text-lg tracking-tight text-slate-100 group-hover:text-white">
                  {s.name}
                </div>
                <div className="font-tech text-[10px] text-slate-500 mt-1">
                  Lead Generation
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
